import { CHANGE_PASSWORD_FAIL, CHANGE_PASSWORD_PENDING, CHANGE_PASSWORD_SUCCESS, RESET_CHANGE_PASSWORD } from "../Types"
import AuthServices from "../../../Services/Auth/AuthServices"
import { toast } from "react-toastify"


export const changePassword = (body) => async (dispatch) => {
    dispatch({
        type: CHANGE_PASSWORD_PENDING,
        payload: { changePassword: "isLoading" },
    });

    try {
        const data = await AuthServices.changePassword(body);

        if (data.data.status === true) {
            dispatch({
                type: CHANGE_PASSWORD_SUCCESS,
                payload: { changePassword: data.data },
            });
            toast.success(data.data.message);
        } else {
            dispatch({ type: CHANGE_PASSWORD_FAIL });
            toast.error(data.data.message);
        }
    } catch (error) {
        console.error("Error:", error);
        dispatch({ type: CHANGE_PASSWORD_FAIL });
        toast.error(error?.response?.data?.message || "An unexpected error occurred");
    }
};

export const resetChangePassword = () => ({
    type: RESET_CHANGE_PASSWORD,
});